export default "__VITE_ASSET__f724f297__"